export const addSpacesToKebabCase = (key: string) => {
    return key.replaceAll("-", " ").toLowerCase();
};
